import React, { memo, useCallback, useMemo } from 'react'
import UnifiedMarker from '@/component/map/unified/UnifiedMarker'

interface IProps {
    markerKey: string
    lat: number
    lng: number
    count: number
    color: string
    onSelect: (markerKey: string) => void
}

const ICON_SIZE = { width: 50, height: 50 }
const iconUrlCache = new Map<string, string>()

const getIconUrl = (color: string, count: number) => {
    const cacheKey = `${color}_${count}`
    let url = iconUrlCache.get(cacheKey)

    if (!url) {
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="${color}" stroke="white" stroke-width="3"/><text x="25" y="30" fill="white" font-size="20" font-family="Arial" text-anchor="middle">${count}</text></svg>`
        url = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
        iconUrlCache.set(cacheKey, url)
    }

    return url
}

const ClusterMarker: React.FC<IProps> = memo(({ markerKey, lat, lng, count, color, onSelect }) => {
    const position = useMemo(() => ({ lat, lng }), [lat, lng])
    const icon = useMemo(() => ({ url: getIconUrl(color, count), scaledSize: ICON_SIZE }), [color, count])
    const handleClick = useCallback(() => onSelect(markerKey), [onSelect, markerKey])

    return <UnifiedMarker position={position} icon={icon} onClick={handleClick} />
})

export default ClusterMarker
